/** What the editor bar says about the draft. 'idle' says nothing: just opened, untouched. */
export type SaveStatus = 'idle' | 'saving' | 'saved' | 'notSaved'

export interface SaveFacts {
  /** An edit waiting for its timer. */
  pending: boolean
  /** A save on its way to the server. */
  inFlight: boolean
  /** The last save was refused or failed. */
  refused: boolean
  /** Saved elsewhere since it was opened: nothing more is sent until Reload. */
  moved?: boolean
  /** When a save last landed (or Ctrl+S found nothing to send), else null. */
  savedAt: number | null
}

export function saveStatus(f: SaveFacts): SaveStatus {
  if (f.moved) return 'notSaved'
  if (f.pending || f.inFlight) return 'saving'
  if (f.refused) return 'notSaved'
  return f.savedAt !== null ? 'saved' : 'idle'
}

/** Why Publish is off, or null when it is on. */
export type PublishBlock = 'saving' | 'notSaved' | 'faults' | 'nothingNew'

export function publishBlock(status: SaveStatus, unpublished: boolean, faulty = false): PublishBlock | null {
  if (status === 'saving') return 'saving'
  if (status === 'notSaved') return 'notSaved'
  if (faulty) return 'faults'
  return unpublished ? null : 'nothingNew'
}
